// Copyright (c) 2019 Deere & Company
import moment from 'moment';
import React from 'react';

const cellRenderer = params => (
    <a name="claimNumber" data-warrantyClaimId={params.data.warrantyClaimId}>
        {params.data.claimNumber}
    </a>
);

const NonDeereColumnDefinitions = [
   
    {
        field: 'claimNumber',
        headerName: 'Claim Number',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
        pinned: 'left',
        cellRenderer,
    },
   
    {
        field: 'claimType',
        headerName: 'Claim Type',
        sortable: true,
        filter: true,
        width: 120
        },
    {
        field: 'countryCode',
        headerName: 'Country Code',
        sortable: true,
        filter: true,
        width: 80,
    },
    {
        field: 'vehicleSerialNum',
        headerName: 'Vehicle Serial Number',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'engineSerialNum',
        headerName: 'Engine Serial Number',
        sortable: true,
        filter: true,
        width: 120,
//valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'deliveryDate',
        headerName: 'Delivery Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'failureDate',
        headerName: 'Failure Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'processingDate',
        headerName: 'Processing Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },    
    {
        field: 'partNumber',
        headerName: 'Part Number',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'partComplaint',
        headerName: 'Part Complaint',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'partDescription',
        headerName: 'Part Description',
        tooltipHeader: 'Part Description',
        sortable: true,
        filter: true,
        minWidth: 90,
    },
    {
        field: 'machineWorkingHours',
        headerName: 'Machine Working Hours',
        tooltipHeader: 'Machine Working Hours',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'totalLabourTime',
        headerName: 'Total Labour Time',
        tooltipHeader: 'Total Labour Time',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'labourCost',
        headerName: 'Labour Cost',
        tooltipHeader: 'Labour Cost',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },

    {
        field: 'labourCostUSD',
        headerName: 'Labour Cost USD',
        tooltipHeader: 'Labour Cost USD',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'partCost',
        headerName: 'Part Cost',
        tooltipHeader: 'Part Cost',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'partCostUSD',
        headerName: 'Part Cost USD',
        tooltipHeader: 'Part Cost USD',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'miscCost',
        headerName: 'Misc Cost',
        tooltipHeader: 'Misc Cost',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'miscCostUSD',
        headerName: 'Misc Cost USD',
        tooltipHeader: 'Misc Cost USD',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'totalCostAccepted',
        headerName: 'Total Cost Accepted',
        tooltipHeader: 'Total Cost Accepted',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'totalCostAcceptedUSD',
        headerName: 'Total Cost Accepted USD',
        tooltipHeader: 'Total Cost Accepted USD',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'uploadBy',
        headerName: 'Uploaded By',
        tooltipHeader: 'Uploaded By',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'updatedBy',
        headerName: 'Updated By',
        tooltipHeader: 'Updated By',
        sortable: true,
        filter: true,
        maxWidth: 150,
    },
    {
        field: 'updatedTs',
        headerName: 'Updated Timestamp',
        tooltipHeader: 'Updated Timestamp',
        sortable: true,
        filter: true,
        valueFormatter: data => data.value ? moment(data.value * 1000).utc().format('MM/DD/YYYY HH:mm:ss') : '',
        maxWidth: 150,
    },

];
export default NonDeereColumnDefinitions;
